import store from "./store";
import axios from "axios";
import { JEET11_API_GATEWAY_BASE_URL } from "../config";
const EventsManager = {
	getUserId: () => store.state.auth.USERID,
	key: "eventsArray",
	currentIdleRequestEventId: 0,
	getKey() {
		return this.key;
	},
	eventsBatchLength: 1,
	EVENT_API_URL:
		JEET11_API_GATEWAY_BASE_URL +
		"event-tracking-service/external/v1.0.0/sendEvent",
	eventObjectBuilder({ name, properties }) {
		const event = {
			name,
			properties: {
				...properties,
				time: Number(new Date()),
				// eslint-disable-next-line no-undef
				client:
					window && window.Android && window.Android.isJeet11RetailApp
						? JSON.stringify(window.Android || {})
						: "web",
				userId: this.getUserId()
			}
		};
		return event;
	},
	isValidDomain() {
		const href = window
			? window.location
				? window.location.href
				: ""
			: "";
		return !(href.includes("http://localhost") || href.includes("dev"));
	},
	sendEvent({ name, properties }) {
		const event = this.eventObjectBuilder({ name, properties });
		if (event.name === "RETAIL_APP_OPEN") {
			event.properties.deviceId = event.properties.userId;
			delete event.properties.userId;
		}
		const sendEventFunction = async id => {
			try {
				await axios.post(this.EVENT_API_URL, event);
			} catch (e) {
				console.error(`could not send event`, event, e);
			} finally {
				if ("cancelIdleCallback" in window)
					window.cancelIdleCallback(id);
			}
		};
		// eslint-disable-next-line no-undef
		if (this.isValidDomain()) {
			if ("requestIdleCallback" in window) {
				this.currentIdleRequestEventId += 1;
				window.requestIdleCallback(
					() => sendEventFunction(this.currentIdleRequestEventId),
					{
						timeout: 10000
					}
				);
			} else {
				sendEventFunction();
			}
		} else {
			console.log({ event });
		}
	}
};
export default EventsManager;
